import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "flex items-center w-full py-2"
};
import { ChevronDownIcon, ChevronRightIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaAccordion',
    props: {
        showToggle: { type: Boolean, default: false },
        open: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const isOpen = ref(true);
        onMounted(() => {
            if (props.showToggle) {
                isOpen.value = props.open;
            }
        });
        const toggleAccordion = () => {
            isOpen.value = !isOpen.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_ctx.showToggle)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleAccordion())),
                        class: "flex items-center pt-2 pb-4 w-fit"
                    }, [
                        _renderSlot(_ctx.$slots, "title"),
                        (isOpen.value)
                            ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                                key: 0,
                                class: "h-5 w-5 mt-[3px] stroke-gray-600"
                            }))
                            : (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
                                key: 1,
                                class: "h-5 w-5 mt-[2px] stroke-gray-600"
                            }))
                    ]))
                    : (_openBlock(), _createElementBlock("button", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "title")
                    ])),
                _createElementVNode("div", {
                    class: _normalizeClass(["transition-all duration-400", {
                            'max-h-100': isOpen.value,
                            'max-h-0': !isOpen.value,
                            'overflow-hidden': !isOpen.value,
                        }])
                }, [
                    _renderSlot(_ctx.$slots, "content")
                ], 2 /* CLASS */)
            ]));
        };
    }
});
